import { isPricingV2Live } from "@repo/config";

const TRIAL_DAYS = 14;

/**
 * The plan a property-level trial runs on: Agency Core. Once the October 2026
 * pricing is live that is the v2 Agency Core; before, the v1 usage-based one.
 */
export function getDefaultTrialPlanId():
	| "agencyCoreV2"
	| "agencyCoreUsageBased" {
	return isPricingV2Live() ? "agencyCoreV2" : "agencyCoreUsageBased";
}

export function getTrialStatusForProperty(
	property: { verifiedAt?: Date | null },
	now: Date = new Date(),
) {
	if (!property.verifiedAt) return null;
	const verifiedAt = new Date(property.verifiedAt);
	const daysSinceVerification = Math.floor(
		(now.getTime() - verifiedAt.getTime()) / (1000 * 60 * 60 * 24),
	);
	const remainingTrialDays = TRIAL_DAYS - daysSinceVerification;
	if (remainingTrialDays > 0) {
		// Typed as string, as it always was: callers compare it with ids that
		// aren't plan keys (e.g. "free").
		const id: string = getDefaultTrialPlanId();
		return {
			id,
			status: "trialing",
			remainingTrialDays,
		};
	}
	return null;
}
